export default __webpack_public_path__ + "static/media/horizontale2.c65d526e.mp4";